import type { IBuilderComponentSdkLoader } from '../../types'

export const createClientBuilderComponentSdkLoader = (): IBuilderComponentSdkLoader => {
	return {
		loadSdk: async (url: string) => {
			// ESM with default export
			return import(/* webpackIgnore: true */ url).then((sdk) => sdk.default)
		},
	}
}
